import { useParams, Navigate } from "react-router-dom";

const FormRedirect = () => {
  const { categorySlug } = useParams();
  
  if (!categorySlug) {
    return <Navigate to="/form" replace />;
  }
  
  return <Navigate to={`/form/${categorySlug}/step1`} replace />;
};

export default FormRedirect;